
const titleObj = {
    "VERIFY_KYC": "KYC Verification",
    "VERIFY_RE_KYC": "RE-KYC Verification",
    "VERIFY_KYC_7_LEVEL": "KYC Verification 7 Level",
    // "VISIT": "Visit",
    "REFUND_DEALER_ADMIN": "Wallet Refund",
    "POLICY_CANCEL": "Policy Cancellation",
    "POLICY_CANCEL_DIRECT": "Policy Cancellation",
    "DOCUMENT_EDIT": "Dcoument Edit",
    "POLICY_EDIT_DIRECT": "Policy Edit",
    "ONLINE": "Payment Gateway",
    "OFFLINE": "EA Wallet",
    "VA_NAVISION_DEALER": "ECollection",
    "VA_NAVISION_ADMIN": "ECollection map",
    "POLICY_REFUND": "Policy refund",
    "REFUND": "Refund",
    "POLICY_REFUND2": "Wallet refund rejected",
    "WALLET_REFUND": "Wallet refund",
    "REFUND_AUTO": "Wallet refund transaction",
    "WALLET_REFUND_AUTO": "Wallet refund transaction",
    "SELF_ONLINE": "Payment Gateway",
    "CLOSOURE_INITIATED": "Closure Initiated",
    "USER_EDIT": "User Edit",
    "INITIATED":"INITIATED",
    "IN TRANSIT":"IN TRANSIT",
    "APPROVED":"APPROVED",
    "REJECTED":"REJECTED",
    "CASHIFY_POLICY_CANCEL" : "Document Cancellation",
    "CASHIFY_POLICY_EDIT" : "Document Edit",
    "proposer_gender":"Proposer Gender",
    "proposer_title":"Proposer Title",
    "proposer_first_name":"Proposer First Name",
    "proposer_middle_name":"Proposer Middle Name",
    "proposer_last_name":"Proposer Last Name",
    "proposer_dob":"Proposer Date of Birth",
    "proposer_email":"Proposer Email",
    "proposer_mobile":"Proposer Mobile",
    "proposer_address":"Proposer Address",
    "proposer_pin_code":"Proposer Pincode",
    "traveller_passport":"Traveller Passport Number",
    "firstName":"Traveller First Name",
    "lastName":"Traveller Last Name",
    "gender":"Traveller Gender",
    "title":"Traveller Title",
    "nominee_relation":"Nominee Relation",
    "nominee_gender":"Nominee Gender",
    "nominee_firstName":"Nominee First Name",
    "nominee_lastName":"Nominee Last Name",
    "nominee_middleName":"Nominee Middle Name",
    "nominee_dob":"Nominee Date of Birth",
    "nominee_title":"Nominee Title",
    "traveller_dob": "Traveller Date of Birth",
    "travel_start_date": "Travel Start Date",
    "travel_end_date": "Travel End Date",
    "number_of_travel_days":"Number Of Travel Days",
    "city" : "Proposer City",
    "state": "Proposer State",
    "VA_CREATE_WALLET_HO": "Wallet Credit",
    "WALLET_DEBIT_HO": "Wallet Debit",
}
const getTitle = (key) => {
   return titleObj[key] ? titleObj[key] : key;
}

export default getTitle;